import { configureStore } from "@reduxjs/toolkit";
import generatesSlice from "./features/generates/generatesSlice";
import userSlice from "./features/auth/authSlice";
import gamesSlice from "./features/games/gamesSlice";
import localStorageMiddleware from "./localStorageMiddleware";
import uiSlice from "./features/ui.slice";

const loadState = () => {
  try {
    if (typeof window !== "undefined") {
      const serializedState = localStorage.getItem("reduxState");
      if (serializedState === null) return undefined;
      return JSON.parse(serializedState);
    }
  } catch (error) {
    console.error("Error loading state:", error);
    return undefined;
  }
};

const preloadedState = loadState();

export const makeStore = () => {
  // const preloadedState = () => {
  //   if (typeof window !== "undefined") {
  //     const savedState = localStorage.getItem("appState");
  //     return savedState ? JSON.parse(savedState) : undefined;
  //   }
  //   return undefined;
  // };
  return configureStore({
    reducer: {
      ui: uiSlice,
      user: userSlice,
      generates: generatesSlice,
      games: gamesSlice,
    },
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(localStorageMiddleware),
  });
};
